import { LocationStrategy } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = '';
  constructor(private locationStrategy: LocationStrategy,private router: Router,private route: ActivatedRoute) { }
  ngOnInit() {
    this.locationStrategy.onPopState(() => {
      history.forward();
    });
    this.router.events.subscribe((event) => {
      if (!(event instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
      this.addHospitalParamToUrl();
  });
    this.storeHospitalName();
  }
  private storeHospitalName(): void {
    this.route.queryParams.subscribe(params => {
      const hospitalName = params['hospital'];
      if (hospitalName) {
        sessionStorage.setItem('hospitalname', hospitalName);
      }
    });
  }

  public getHospitalName(): string | null {
    return sessionStorage.getItem('hospitalname');
  }

  private addHospitalParamToUrl(): void {
    const hospitalName = this.getHospitalName();
    if (hospitalName) {
      this.router.navigate([], {
        queryParams: { hospital: hospitalName },
        queryParamsHandling: 'merge' // merge with existing query params
      });
    }
  }

}
